import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import {Constants} from '../constants/ebtq-constants';

@Component({
  standalone: false,
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {


  isAdmin = false;
  isDeveloper = false;
  rmIntView = false;
  rmIntUpdate = false;
  rmExtSerView = false;
  rmExtDelView = false;
  rmExtDelUpdate = false;
  rmExtSerpdate = false;
  currentMenuOption!: string;
  currentSubMenuOption!: string;
  pdfName!: string;

  constructor(private location: Location) { }

  ngOnInit(): void {

    console.log('help menu');
    this.isAdmin = JSON.parse(sessionStorage.getItem('isAdmin') ?? 'false');
    this.isDeveloper = JSON.parse(sessionStorage.getItem('isDeveloper') ?? 'false');
    this.rmIntView = JSON.parse(sessionStorage.getItem('isRMInternal_View') ?? 'false');
    this.rmIntUpdate = JSON.parse(sessionStorage.getItem('isRMInternal_Update') ?? 'false');
    this.rmExtSerView = JSON.parse(sessionStorage.getItem('isRMExternal_Servicing_View') ?? 'false');
    this.rmExtSerpdate = JSON.parse(sessionStorage.getItem('isRMExternal_Servicing_Update') ?? 'false');
    this.rmExtDelView = JSON.parse(sessionStorage.getItem('isRMExternal_Delivery_View') ?? 'false');
    this.rmExtDelUpdate = JSON.parse(sessionStorage.getItem('isRMExternal_Delivery_Update') ?? 'false');


    this.currentSubMenuOption = sessionStorage.getItem('currentSubMenuOption') ?? '';
    this.currentMenuOption = sessionStorage.getItem('currentmenuOption') ?? '';
    this.helpMethod();

  }

  isDeliveryuser()
  {
    if (this.rmExtDelView || this.rmExtDelUpdate || this.isAdmin
     || this.isDeveloper || this.rmIntView || this. rmIntUpdate)
    {
      return true;
    }
    return false;
  }

  helpMethod()
  {
    if (this.currentMenuOption === Constants.REVERSE_MORTGAGE) {
      /* if(this.currentSubMenuOption != null && this.currentSubMenuOption.length >0)
      {*/
      if (this.currentSubMenuOption === Constants.RM_SERVICING)
      {
        this.pdfName = 'RM_Servicing_Users_Guide';
      }
      else if (this.currentSubMenuOption === Constants.RM_DELIVERY)
      {
        this.pdfName = 'RM_Delivery_Users_Guide';

      }
      else {
        if (this.isDeliveryuser())
        {
          this.pdfName = 'RM_Delivery_Users_Guide';
        }
        else {
          this.pdfName = 'RM_Servicing_Users_Guide';
        }

      }
      // }


    }
    else {
      if (this.isDeliveryuser())
      {
        this.pdfName = 'RM_Delivery_Users_Guide';
      }
      else {
        this.pdfName = 'RM_Servicing_Users_Guide';
      }
    }

    const hostname = window.location.hostname;
    console.log('hostname', hostname);

    if (hostname === 'localhost')
    {
      window.open('http://localhost:4200/assets/pdf/' + this.pdfName + '.pdf', '_blank');
    }
    else {
      window.open('http://' + hostname + '/assets/pdf/' + this.pdfName + '.pdf', '_blank');
    }

    // window.open('http://localhost:4200/assets/pdf/'+this.pdfName+'.pdf','_blank');
    this.location.back();
  }

}
